import { RouteItem } from '@eastcoal/router/types/route'

import {
  RECHARGE_APPLY_CREATE_PAGE_PATH,
  RECHARGE_APPLY_LIST_PAGE_PATH
} from './constants/path'
import {
  RECHARGE_APPLY_AUDIT_ACTION_UUID,
  RECHARGE_APPLY_CREATE_PAGE_UUID,
  RECHARGE_APPLY_LIST_PAGE_UUID
} from './constants/uuid'

export const rechargeApplyRoute: RouteItem = {
  title: '账号充值',
  children: [
    {
      title: '立即充值',
      path: RECHARGE_APPLY_CREATE_PAGE_PATH,
      uuid: RECHARGE_APPLY_CREATE_PAGE_UUID,
      Component: () => import('./Form')
    },
    {
      title: '充值记录',
      path: RECHARGE_APPLY_LIST_PAGE_PATH,
      uuid: RECHARGE_APPLY_LIST_PAGE_UUID,
      Component: () => import('./List')
    },
    {
      title: '充值审批',
      uuid: RECHARGE_APPLY_AUDIT_ACTION_UUID
    }
  ]
}
